<template>
  <div>
    <b-button class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="apriModalUvoxy">
      <div><img :src="'/img/uvoxyIcon.png'" style="height:22px; width:auto" class="mr-2">SanificaAria</div>
    </b-button>

    <!-- Uvoxy command Modal-->
    <b-modal
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      id="modal-parametri-uvoxy"
      :title="$t('parametri_uvoxy_modal.title')"
      :ok-title="$t('parametri_uvoxy_modal.button_salva')"
      @ok="handleOk"
    >
      <!-- Sanificazione ON-OFF -->
      <b-form-group>
        <b-row>
        <b-col cols="5">  
          <img :src="'/img/uvoxyIcon.png'" style="height:22px; width:auto" class="pull-left ml-2">
          <div class="pull-left mt-1 mr-4 ml-2 typo-label">{{$t("parametri_uvoxy_modal.sanifica")}}</div>
        </b-col>
        <b-col cols="7">  
          <div class="pull-left">
            <toggle-switch
              :options="optionsOnOff"
              v-model="onoff_value"
            />
          </div>

        </b-col>    
        </b-row>
      </b-form-group>

      <!-- Velocità ventola -->
      <b-form-group>
        <b-row>
        <b-col cols="5">  
          <img :src="'/img/ventola.png'" style="height:auto; width:24px" class="pull-left mt-1 ml-2">
          <div class="pull-left mt-1 mr-4 ml-2 typo-label">{{$t("parametri_uvoxy_modal.fan")}}</div>
        </b-col>
        <b-col cols="7">
          <toggle-switch
            :options="optionsFan"
            v-model="fanValue"
          />
        </b-col>    
        </b-row>
      </b-form-group>

      <!-- Profilo sanificazione -->
      <b-form-group>
        <b-row>
        <b-col cols="5">  
          <img :src="'/img/timer.png'" style="height:22px; width:auto" class="pull-left ml-2">
          <div class="pull-left mt-1 mr-4 ml-2 typo-label">{{$t("parametri_uvoxy_modal.timer")}}</div>
        </b-col>
        <b-col cols="7">
          <div class="pull-left">
          <toggle-switch
            :options="optionsProfile"
            v-model="timerValue"
          />
          </div>
          <span content="24h: always on <br> 12h+12h: 12 hours and 12 hours off <br> 8h+16h: 8 hours on and 16 hours off" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-info-circle ml-3 mt-2" style="color:#009DE0" ></i></span>

        </b-col>    
        </b-row>
      </b-form-group>


    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ToggleSwitch from 'vuejs-toggle-switch'

export default {
  name: "ParametriUvoxy",
  
  data() {
    return {
      optionsOnOff: {
          layout: {
            color: 'black',
            backgroundColor: 'white',
            selectedColor: 'white',
            selectedBackgroundColor: 'blue',
            borderColor: 'grey',
            fontFamily: 'Roboto',
            fontWeight: 'normal',
            fontWeightSelected: 'bold',
            squareCorners: false,
            noBorder: false
          },
          size: {
            fontSize: 0.8,
            height: 1.8,
            padding: 0.2,
            width: 5
          },
          items: {
            delay: .4,
            preSelected: '',
            disabled: false,
            labels: [
              {name: 'OFF', color: 'white', backgroundColor: ' #009DE0'},
              {name: 'ON', color: 'white', backgroundColor: ' #009DE0'}
            ]
          }
      },
      optionsFan: {
          layout: {
            color: 'black',
            backgroundColor: 'white',
            selectedColor: 'black',
            selectedBackgroundColor: 'blue',
            borderColor: 'grey',
            fontFamily: 'Roboto',
            fontWeight: 'normal',
            fontWeightSelected: 'bold',
            squareCorners: false,
            noBorder: false
          },
          size: {
            fontSize: 0.8,
            height: 1.8,
            padding: 0.2,
            width: 10
          },
          items: {
            delay: .4,
            preSelected: '',
            disabled: false,
            labels: [
              {name: '1', color: 'white', backgroundColor: ' #009DE0'}, 
              {name: '2', color: 'white', backgroundColor: ' #009DE0'},
              {name: '3', color: 'white', backgroundColor: ' #009DE0'}
            ]
          }
      },
      optionsProfile: {
          layout: {
            color: 'black',
            backgroundColor: 'white',
            selectedColor: 'black',
            selectedBackgroundColor: 'blue',
            borderColor: 'grey',
            fontFamily: 'Roboto',
            fontWeight: 'normal',
            fontWeightSelected: 'bold',
            squareCorners: false,
            noBorder: false
          },
          size: {
            fontSize: 0.8,
            height: 1.8,
            padding: 0.2,
            width: 12
          },
          items: {
            delay: .4,
            preSelected: '',
            disabled: false,
            labels: [
              {name: '24h', color: 'white', backgroundColor: ' #009DE0'},
              {name: '12+12h', color: 'white', backgroundColor: ' #009DE0'}, 
              {name: '8+16h', color: 'white', backgroundColor: ' #009DE0'}
            ]
          }
      },
      footer_hide: false,
      onoff_value:"",
      fanValue: "",
      timerValue: "",
      fanDisabled: true,
      timerDisabled: true,
    };
  },
  props: {
    cu:null,
    lamp:null,
    sendAction: null,
    alerts:null
  },
  computed: {

        },
  methods: {
     apriModalUvoxy() {
      if (this.cu.length>0 || this.lamp.length>0)
      {
          this.$bvModal.show('modal-parametri-uvoxy')
      }
      else
      {
        var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: this.$t('parametri_impianto_modal.error_select'),
                    countDownChanged: function(cd) {
                    }
                }
        this.alerts.push(alert);  
      }

     },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveParam();
    },
    saveParam() {

      var params = {};
      params.command = "setMultiParam";
      params.autonomy = "";
      params.parity = "";
      params.mode = "";
      params.infinity = "";
      params.opticom = "";
      params.durataTest = "";  
      params.uvOxyOnOff = this.onoff_value;
      params.uvOxyFanSpeed = this.fanValue;
      params.uvOxyTimer = this.timerValue;  
    
      console.log("parametri oxy:", params);
      //Decommentare questo quando sarà implementato il comando reale
      this.sendAction(params);

      
      
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });

    },

    OnlyHexInString(hex) {
      return !isNaN(Number("0x" + hex));
    }
  }
};
</script>
